<template>
  <div class="container-fluid">
    <vk-offcanvas-content>
      <vk-offcanvas flipped overlay stuck :show.sync="showSetup">
        <vk-offcanvas-close @click="showSetup = false"></vk-offcanvas-close>
        <SetupArnergyProduct />
      </vk-offcanvas>
    </vk-offcanvas-content>

    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1; margin-left: 25px; ">Arnergy Product</h2>
        <div
          v-if="usertype != 'customer admin'"
          style="display: flex; margin-right: 20px;"
        >
          <span
            style="flex: 1; align-items: center; margin-right: 10px; margin-top: 12px;"
          >
            <button
              class="btn btn-xl btn-primary create_button"
              @click="showSetup = true"
            >
              + Create Product
            </button>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <ListArnergyProduct />
            </can>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListArnergyProduct from "../AdminOnboarding/ListArnergyProduct.vue";
import SetupArnergyProduct from "../AdminOnboarding/SetupArnergyProduct.vue";

import {
  Offcanvas,
  OffcanvasClose,
  OffcanvasContent
} from "vuikit/lib/offcanvas";

export default {
  name: "ArnergyProducts",
  components: {
    "vk-offcanvas-content": OffcanvasContent,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    ListArnergyProduct,
    SetupArnergyProduct
  },
  data() {
    return {
      flipped: false,
      push: false,
      showOffCanvas: false,
      activeTab: "user_list",
      usertype: localStorage.roleType,
      showSetup: false,
      flipped: true
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.create_button {
  border-radius: 10px;
  box-shadow: 0px 2px 4px #42659b;
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/AdminOnboarding/AdminArnergyProduct.vue